// extracted by mini-css-extract-plugin
export default {"wrapper":"FU70Vza99X_pdp","popover":"jTQ7Ap7e_E_pdp","openPopover":"MMGnmjQMY2_pdp","buttonWrapper":"U3kjW8EOQG_pdp","wideButton":"tBdGUbPtRi_pdp","menuItem":"_kB2v2jzA0_pdp"};